import styled from "styled-components";
import Container from "../../reusable-components/container/Container";

export const StyledContainer = styled(Container)`
  height: calc(100vh - 84px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
